import styles from './filter-chip.module.scss';
import ChevronDownIcon from '@/assets/icons/chevron-down.svg?react';
import { classnames } from '@/utils/functions';
import useResponsive from '@/hooks/useResponsive';
import { FC } from 'react';

interface FilterChipProps {
  label: string;
  value: string;
  fallbackValue?: string;
  handleClick: () => void;
  className?: string;
}

const FilterChip: FC<FilterChipProps> = ({
  label,
  value,
  fallbackValue = 'All',
  handleClick,
  className = '',
}) => {
  const itemsStr = value || fallbackValue;
  const { isMobile } = useResponsive();
  return (
    <div
      className={classnames(styles['filter-chip'], className, {
        [styles['has-values']]: itemsStr !== fallbackValue,
      })}
    >
      <span className={styles['filter-chip-label']}>{label}:</span>
      <button
        className={styles['filter-chip-btn']}
        title={itemsStr}
        onClick={() => {
          handleClick();
        }}
      >
        <p className={styles['filter-chip-btn-text']}>
          {isMobile ? <>{label}</> : itemsStr}
        </p>
        <ChevronDownIcon className={styles['filter-chip-btn-icon']} />
      </button>
    </div>
  );
};

export default FilterChip;
